<app-home [titre]="title"
          [homeApplication]="null"
          [menu]="menu"
          [avatar]="false"
          [miniSidenav]="false"
          [displayLogon]="true"
          [anonymous]="false"
          class="mat-typography"
          [darkTheme]="false" version="1.6"
          [displaySidenav]="false"
          [customNavBackground]="mainStyle.navBackground"
          [customNavFontColor]="mainStyle.navFontColor"
          [bodyBgColor]="mainStyle.bodyBgColor"
          [showAccessibility]="false">
</app-home>

<p8-spinner></p8-spinner>
